/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import GraphView from './GraphView';
import { GraphTitle } from '../Utils/CSS/styles';
// import { constant } from '../Utils/constants';

const GraphComponent = (props) => {
  
  const [FilterData, setFilterData] = useState(props.FilterData || []);
  const [OperatorList, setOperatorList] = useState(props.OperatorList || []);
  const [codeType,setCodeType] = useState(props.CodeType || 'Device');
  // const [ObservationList, setObservationList] = useState([]);
  useEffect(() => {
    if (props.FilterData !== FilterData) {
      setFilterData(props.FilterData);
    }
    if (props.OperatorList !== OperatorList) {
      setOperatorList(props.OperatorList);
    }
    if (codeType !== props.CodeType) {
      setCodeType(props.CodeType);
    }
  }, [props.FilterData, props.OperatorList,props.CodeType]);

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
      {FilterData &&
        Array.isArray(FilterData) &&
        FilterData.map((filter, index) => {
          return (
            <div style={{ margin: '5px', width: '500px', height: '400px' }} key={index}>
               {codeType === 'Device' ? (
                  <GraphTitle>
                    {filter.DeviceName}-{filter.ParameterName}
                  </GraphTitle>
                ) : (
                  <GraphTitle>
                    {filter.AssetName}-{filter.ParameterName}
                  </GraphTitle>
                )}

              <div
                style={{ margin: '5px 0px', display: 'flex', justifyContent: 'flex-end' }}
              ></div>
              <GraphView
                  payload={filter}
                  OperatorList={OperatorList}
                  index={index}
                  CodeType={codeType}
                />

            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});

export default connect(mapStateToProps)(GraphComponent);